import SubmissionAutonomousCreationModal from './SubmissionAutonomousCreationModal';

export default SubmissionAutonomousCreationModal;
